/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadydone2Inputs */

const en_searchreadydone2 = /** @type {(inputs: Searchreadydone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All there. Your place is ready.`)
};

const de_searchreadydone2 = /** @type {(inputs: Searchreadydone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles da. Dein Ort ist bereit.`)
};

/**
* | output |
* | --- |
* | "All there. Your place is ready." |
*
* @param {Searchreadydone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadydone2 = /** @type {((inputs?: Searchreadydone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadydone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadydone2(inputs)
	return de_searchreadydone2(inputs)
});
export { searchreadydone2 as "searchReadyDone" }